export const METRIC_REGION_CODE = 'Region';
